import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import LoadingSpinners from '@/components/r3f/LoadingSpinners/LoadingSpinners';
import { useThree } from '@react-three/fiber';
import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { IScreenRelativeDeviceLabels } from '../../../../../../typings';
import { createCanvasR3fComponents, useGetActiveSceneScreenContentId, useGetScreenRelativeScaleNormalizationFactor } from '../../../../../utils';
import { getAnchorGroupPrositionDict } from '../../../r3f-components/utils/screen-relative';
import { dummyDeviceToViewportHeightDataDict } from '../../utils';
const AnchorGroups = () => {
    const { size } = useThree();
    const activeScreenContentId = useGetActiveSceneScreenContentId();
    const componentsById = useSelector((state) => state.contentReducer.contentDoc.componentsById);
    const screenRelativeContentScaleType = useSelector((state) => state.contentReducer.contentDoc.screenRelativeScaleType);
    const dummyDevice = useSelector((state) => state.userReducer.screenRelativeDevice);
    const anchorGroupPositionDict = getAnchorGroupPrositionDict(size, screenRelativeContentScaleType);
    const hiddenEntities = Object.keys(componentsById).filter((entityId) => !!componentsById[entityId].isHidden);
    const activeScreenContent = componentsById[activeScreenContentId];
    const spinnerData = useSelector((state) => state.userReducer.spinnerData);
    const normalizationFactor = useGetScreenRelativeScaleNormalizationFactor();
    const dummyDeviceViewportData = dummyDeviceToViewportHeightDataDict[dummyDevice.label];
    const anchorGroups = activeScreenContent.children.map((id) => {
        const anchorGroup = componentsById[id];
        const anchorR3fComponents = createCanvasR3fComponents({
            ids: anchorGroup.children,
            hiddenEntityIds: hiddenEntities,
            componentsById,
        });
        let dummyNormalizationFactor = 1;
        if (screenRelativeContentScaleType === 'absolute') {
            if (dummyDevice.label !== IScreenRelativeDeviceLabels.CUSTOM) {
                dummyNormalizationFactor = size.height / (dummyDeviceViewportData.visibleHeight ?? size.height);
            }
            else
                dummyNormalizationFactor = size.height / dummyDevice.height;
        }
        return (_jsxs("group", { scale: normalizationFactor * dummyNormalizationFactor, name: anchorGroup.anchorPositionType, position: anchorGroupPositionDict[anchorGroup.anchorPositionType], children: [anchorR3fComponents, anchorGroup.anchorPositionType === 'center' && _jsx(LoadingSpinners, { isScreenRelativeSpinners: true, spinnerDataArray: Object.values(spinnerData) })] }, anchorGroup.anchorPositionType));
    });
    return _jsx(_Fragment, { children: anchorGroups });
};
export default memo(AnchorGroups);
